export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";